var pkg = require("./package.json");

module.exports = {
  build: require("./lib/build"),
  create: require("./lib/create"),
  console: require("./lib/repl"),
  contracts: require("truffle-workflow-compile"),
  package: require("./lib/package"),
  test: require("./lib/test"),
  version: pkg.version,
  ganache: require("ganache-core")
};



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-core/index.js
// module id = 3473
// module chunks = 1